import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SignedDocumentDto } from "../../autogen/bff-api";

export const MergedDocumentsModal = ({
  signedDocument,
  onClose,
}: {
  signedDocument: SignedDocumentDto;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  const { mergedDocuments } = signedDocument;
  if (!mergedDocuments) return null;
  const mergedDocumentNames = [
    ...(mergedDocuments.mainDocument ? [mergedDocuments.mainDocument.name] : []),
    ...(mergedDocuments.mainTextDocument ? [mergedDocuments.mainTextDocument.name] : []),
    ...mergedDocuments.attachments.map((d) => d.name),
  ];

  return (
    <Modal isOpen={true} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("Merged documents")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="6">
          <Flex flexDirection="column" gap="2">
            {mergedDocumentNames.map((name, i) => (
              <Text key={i} fontSize="sm">
                {name}
              </Text>
            ))}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
